export const TaxPayerIdentificationType = {
  EmployerIdentificationNumber: 'EIN',
  SocialSecurityNumber: 'SSN',
} as const;
export type TaxPayerIdentificationType =
  (typeof TaxPayerIdentificationType)[keyof typeof TaxPayerIdentificationType];

export const FederalTaxClassification = {
  'Individual/sole Proprietor': 'Individual/sole Proprietor',
  'C Corporation': 'C Corporation',
  'S Corporation': 'S Corporation',
  Partnership: 'Partnership',
  'Trust/Estate': 'Trust/Estate',
  'LLC classified as C Corporation': 'LLC classified as C Corporation',
  'LLC classified as S Corporation': 'LLC classified as S Corporation',
  'LLC classified as Partnership': 'LLC classified as Partnership',
  Other: 'Other',
} as const;
export type FederalTaxClassification =
  (typeof FederalTaxClassification)[keyof typeof FederalTaxClassification];

export interface PartnerAddress {
  address: string;
  address2: string;
  city: string;
  state: string;
  zipcode: string;
}

export class Partner {
  public legalName: string;
  public dba: string;
  public taxpayerIdentificationType: TaxPayerIdentificationType;
  public taxpayerIdentificationNumber: string;
  public federalTaxClassification: FederalTaxClassification;
  public address: PartnerAddress;

  constructor(
    name: string,
    dba: string | null,
    identificationType: TaxPayerIdentificationType,
    identificationNumber: string,
    federalTaxClassification: FederalTaxClassification,
    address: PartnerAddress
  ) {
    this.legalName = name;
    this.dba = dba || '';
    this.taxpayerIdentificationType = identificationType;
    this.taxpayerIdentificationNumber = identificationNumber;
    this.federalTaxClassification = federalTaxClassification;
    this.address = address;
  }
}
